import { render, staticRenderFns } from "./feedback-page.vue?vue&type=template&id=182fbaa5&scoped=true&"
import script from "./feedback-page.vue?vue&type=script&lang=js&"
export * from "./feedback-page.vue?vue&type=script&lang=js&"
import style0 from "./components/feedback.css?vue&type=style&index=0&id=182fbaa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182fbaa5",
  null
  
)

export default component.exports